import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { KurtiRepeat } from "./repeat/kurtiRepeat.mjs";
import { HoodieRepeat } from "./repeat/hoodieRepeat.mjs";
import { JacketRepeat } from "./repeat/jacketRepeat.mjs";
import { LeggingsRepeat } from "./repeat/leggingsRepeat.mjs";
import { SareeRepeat } from "./repeat/sareeRepeat.mjs";
import { ShawlRepeat } from "./repeat/shawlRepeat.mjs";
import { ShirtRepeat } from "./repeat/shirtRepeat.mjs";
import { SkirtRepeat } from "./repeat/skirtRepeat.mjs";
import { TopRepeat } from "./repeat/topRepeat.mjs";
import { TracksuitRepeat } from "./repeat/tracksuitRepeat.mjs";
import { LehengaRepeat } from "./repeat/lehengaRepeat.mjs";
import { DressRepeat } from "./repeat/dressRepeat.mjs";
import { CoordRepeat } from "./repeat/coordRepeat.mjs";
import { JeansRepeat } from "./repeat/jeansRepeat.mjs";
import { EarringRepeat } from "./repeat/earringsRepeat.mjs";
import { BandRepeat } from "./repeat/sacretBandRepeat.mjs";
import { HandBagRepeat } from "./repeat/handBagRepeat.mjs";
import { HandPurseRepeat } from "./repeat/handPurseRepeat.mjs";
import { WalletRepeat } from "./repeat/walletRepeat.mjs";
import { BackpackRepeat } from "./repeat/backRepeat.mjs";
import { BeltRepeat } from "./repeat/beltRepeat.mjs";
import { UmbrellaRepeat } from "./repeat/umbrellaRepeat.mjs";

function Repeat({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;

    let [prod, setProdInfo] = useState({});

    let navigate = useNavigate();

    const { prodType, prodId } = useParams();
    let jToken = localStorage.getItem('token');

    useEffect(() => {
        setProdInfo(prev => {
            return ({ ...prev, 'prod': prodType })
        });
    }, [prodType]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseData = await fetch(`${apiURL}/api/repeat/${prodType}/${prodId}`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: "include"
                })

                if (responseData.status === 200) {
                    let res = await responseData.json();
                    setProdInfo(prev => {
                        return { ...prev, ...res }
                    });
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }

        fetchData();
    }, [jToken, loginStatus, prodId, navigate, apiURL, prodType]);

    return (
        <>
            {prod && (
                ['Shirt', 'T-shirt'].includes(prod['genre']) ?
                    (<ShirtRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                    prod.genre === 'Hoodie' ?
                        (<HoodieRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                        prod.genre === 'Jacket' ?
                            (<JacketRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                            prod.genre === 'Saree' ?
                                (<SareeRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                prod.genre === 'Shawl' ?
                                    (<ShawlRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                    prod.genre === 'Tracksuit' ?
                                        (<TracksuitRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                        prod.genre === 'Leggings' ?
                                            (<LeggingsRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                            prod.genre === 'Skirt' ?
                                                (<SkirtRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                prod.genre === 'Lehenga' ?
                                                    (<LehengaRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                    prod.genre === 'Dress' ?
                                                        (<DressRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                        prod.genre === 'Top' ?
                                                            (<TopRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                            prod.genre === 'Co ord set' ?
                                                                (<CoordRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                prod.genre === 'Jeans' ?
                                                                    (<JeansRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                    ['Kurti', 'Kurta'].includes(prod['genre']) ?
                                                                        (<KurtiRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                        prod.genre === 'Ear rings' ?
                                                                            (<EarringRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                            prod.genre === 'Band' ?
                                                                                (<BandRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                prod.genre === 'Hand bag' ?
                                                                                    (<HandBagRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                    prod.genre === 'Hand purse' ?
                                                                                        (<HandPurseRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                        prod.genre === 'Wallet' ?
                                                                                            (<WalletRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                            prod.genre === 'Backpack' ?
                                                                                                (<BackpackRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                prod.genre === 'Belt' ?
                                                                                                    (<BeltRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                    prod.genre === 'Umbrella' ?
                                                                                                        (<UmbrellaRepeat prod={prod} setProdInfo={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                        (<></>)
            )}
        </>
    )
}

export default Repeat;